import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SendToIntacctInvoice } from './send-to-intacct-invoice.model';
import { ToastService } from '../../../shared/toast.service';
import { StorageService } from '../../../views/storage/storage.service';
import { AccountingService } from '../../../views/accounting/accounting.service';
import { FreightService } from '../../../views/freight/freight.service';

@Component({
	selector: 'send-to-intacct',
	styleUrls: ['./send-to-intacct.component.css'],
	templateUrl: './send-to-intacct.component.html'
})
export class SendToIntacctComponent implements OnInit {
	@Input() isMultiple: boolean;
	@Input() isSent: boolean;
	@Input() page: string;
	@Input() type: string;
	@Input() data: any;
	@Input() lockActionButtons = false;
	@Input() byPassVendorDueDateTerm = false;
  @Output() onButtonClick = new EventEmitter();

	selectedInvoices: SendToIntacctInvoice[];
	selectedInvoice: SendToIntacctInvoice;
	intacctResponse: any[] = new Array<any>();
	purchaseOrderPaymentStatus: string;
	purchaseOrderState: string;
	sendingRequestToIntacct: boolean;
	lockActions = false;
	processingPeriod: Date;
	height = '40vh';
	canReverse = false;
	showSendToIntacctPanel: boolean = false;
	public showIntacctResponseSidePanel: boolean = false;
	constructor(
		private storageService: StorageService,
		private freightService: FreightService,
		private accountingService: AccountingService,
		private toastr: ToastService) {
	}

	ngOnInit() {
		this.showSendToIntacctPanel = true;
		if (!this.data) {
			if (this.isMultiple) {
				this.selectedInvoices = new Array<SendToIntacctInvoice>();
			} else {
				this.selectedInvoice = new SendToIntacctInvoice();
			}
		} else {
			if (this.isMultiple) {
				this.selectedInvoices = new Array<SendToIntacctInvoice>();
				this.data.forEach(invoice => {
					const sendToIntacctInvoice = new SendToIntacctInvoice(invoice);
					sendToIntacctInvoice.glPostingDate = new Date (Date.now());
					sendToIntacctInvoice.invoicingParty = invoice.storageInitial? invoice.storageInitial: invoice.facilityCode? invoice.facilityCode : 'unknown';
					this.selectedInvoices.push(sendToIntacctInvoice);
					if (!this.byPassVendorDueDateTerm) {
						this.loadAPIntacctData(sendToIntacctInvoice);
					}						
				});
			} else {
				this.selectedInvoice = new SendToIntacctInvoice(this.data);
				this.selectedInvoice.glPostingDate = new Date(Date.now());
				if (this.isSent) {
					this.loadAPReverseIntacctData();
				} else if (!this.byPassVendorDueDateTerm) {
					this.loadAPIntacctData(this.selectedInvoice);
				}
			}
		}
		this.accountingService.getOpenPeriodStart().subscribe(result => this.processingPeriod = new Date(result));
	}

	get isLoadingIntacctData(): boolean {
		if (this.isMultiple) {
			return (this.selectedInvoices === undefined) ? false : !!this.selectedInvoices.find(x => x.loadingIntacctData) || this.sendingRequestToIntacct;
		} else {
			return this.selectedInvoice.loadingIntacctData || this.sendingRequestToIntacct;
		}
	}

	get disableSendToIntacct(): boolean {
		if (this.isMultiple) {
			return !this.processingPeriod || this.lockActions || (this.selectedInvoices === undefined)
				? false
				: !this.selectedInvoices.every(x => !!(x.invoiceDate && (x.invoiceReceivedDate || this.page.toLocaleLowerCase() == 'storage') && x.accountingDueDate && x.glPostingDate));
		} else {
			return (!this.processingPeriod || this.lockActions ||
				!(this.selectedInvoice.invoiceDate &&
					this.selectedInvoice.accountingDueDate &&  this.selectedInvoice.glPostingDate));
		}
	}

	private loadAPIntacctData(invoice: SendToIntacctInvoice) {
		invoice.loadingIntacctData = true;
		this.accountingService.getVendorDueDateTerm(invoice.facilityId).subscribe(result => {
			if (invoice.accountingInvoiceDate) {
				invoice.accountingDueDate = new Date(invoice.accountingInvoiceDate);
				invoice.accountingDueDate.setDate(invoice.accountingDueDate.getDate() + result);
			}
			invoice.loadingIntacctData = false;
		}, errorResult => {
			invoice.loadingIntacctData = false;
			this.toastr.error(errorResult.error ? errorResult.error.Message : 'Error', 'Error fetching Vendor info from Intacct.');
		});
	}

	private loadAPReverseIntacctData() {
		this.selectedInvoice.loadingIntacctData = true;
		this.canReverse = false;
		const isVendorRailroad = this.page.toLocaleLowerCase() === 'freight';
		this.accountingService.getPurchaseOrder(this.selectedInvoice.invoiceNumber, this.selectedInvoice.facilityId, isVendorRailroad).subscribe(result => {
			if (result != null) {
				this.selectedInvoice.glPostingDate = new Date(result.glPostingDate);
				this.selectedInvoice.purchaseOrderPaymentStatus = result.paymentStatus;
				this.selectedInvoice.purchaseOrderState = result.state;
				this.selectedInvoice.loadingIntacctData = false;
				this.canReverse = true;
			} else {
				this.toastr.error('Purchase Order was not found', 'Error fetching PO from Intacct.');
				this.selectedInvoice.loadingIntacctData = false;
			}
		}, errorResult => {
			this.selectedInvoice.loadingIntacctData = false;
			this.toastr.error(errorResult.error ? errorResult.error.Message : 'Error', 'Error fetching PO from Intacct.');
		});
	}

	public sendToIntacct() {
		this.lockActions = this.lockActionButtons;
		this.sendingRequestToIntacct = true;
		this.intacctResponse = [];
		if (this.page) {
			switch (this.page.toLocaleLowerCase()) {
				case 'storage':
					if (this.isMultiple) {
						this.storageService
							.sendAPStorageAccountsPayables(this.selectedInvoices)
							.subscribe((result) => this.onNext(result), (errorResult) => this.onError(errorResult));
					} else {
						this.selectedInvoice.loadingIntacctData = true;
						this.storageService.sendAPStorageAccountsPayables([this.selectedInvoice])
							.subscribe((result) => this.onNext(result), (errorResult) => this.onError(errorResult));
						this.selectedInvoice.loadingIntacctData = false;
					}
					break;
				case 'freight':
					if (this.isMultiple) {
						this.freightService
							.sendAPFreightAccountsPayables(this.selectedInvoices)
							.subscribe((result) => this.onNext(result), (errorResult) => this.toastr.error(errorResult));
					} else {
						this.selectedInvoice.loadingIntacctData = true;
						this.freightService.sendAPFreightAccountsPayables([this.selectedInvoice])
							.subscribe((result) => this.onNext(result), (errorResult) => this.toastr.error(errorResult));
						this.selectedInvoice.loadingIntacctData = false;
					}
					break;
				default:
					break;
			}
		}
	}

	public reverseFromIntacct() {
		this.lockActions = this.lockActionButtons;
		this.sendingRequestToIntacct = true;
		this.intacctResponse = [];

		if (this.page) {
			switch (this.page.toLocaleLowerCase()) {
				case 'storage':
					this.storageService
						.reverseAPStorageAccountsPayable(this.selectedInvoice.id)
						.subscribe((result) => this.onNext(result), (errorResult) => this.onError(errorResult));
					break;
				case 'freight':
					this.freightService
						.reverseAPFreightAccountsPayable(this.selectedInvoice.id)
						.subscribe((result) => this.onNext(result), (errorResult) => this.toastr.error(errorResult));
					break;
				default:
					break;
			}
		}
	}

	private onNext(result) {
		this.sendingRequestToIntacct = false;
		result.forEach(x => this.intacctResponse.push({ message: x }));
		if (this.intacctResponse.length > 0)
		{
			this.showIntacctResponseSidePanel = true;
			if (!this.isMultiple)
			{
				if (!this.isSent)
				{
					const sentOk = this.intacctResponse.some(x=> x.message.includes('Purchasing Document was created for'))
								 && !this.intacctResponse.some(x=> x.message.includes('Purchasing Document was NOT created for'));
					this.isSent = sentOk;
					this.canReverse = sentOk;
					this.lockActions = !sentOk;
				}
				else
				{
					this.lockActions = true; 
				}
			}
			else
			{
				//disable Send To Intacct button
				this.lockActions = true;
			}
		}
		this.toastr.success('See response from Intacct below.', 'Action completed!', {
			timeOut: 3000
		});
	}

	public toggleIntacctResponseSidePanel() {
		this.showIntacctResponseSidePanel = !this.showIntacctResponseSidePanel;
	}

	public closeComponent() {
		this.showSendToIntacctPanel = false;
		this.onButtonClick.emit(this.intacctResponse? this.intacctResponse.map(x=>x.message) : []);
	}

	public getMarginAboveGrid() {
		return 'calc((calc(' + this.height + ' - 110px) * .3) / 2)';
	}

	public getLoadingDivHeight() {
		return 'calc(calc(' + this.height + ' - 110px) * .3)';
	}

	public getGridHeight() {
		return 'calc(calc(' + this.height + ' - 150px) * .7)';
	}

	private onError(errorResult) {
		this.sendingRequestToIntacct = false;
		this.onButtonClick.emit([]);
		this.toastr.error((errorResult.error && errorResult.error.Message) || errorResult.message,
			this.isSent ? 'Reverse from Intacct failed.' : 'Send to Intacct failed.');
	}
}
